import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { MoveRouteJobComponent } from './move-route-job.component';
import { RoutePickerModule } from '../route-picker/route-picker.module';
import { BryntumCoreModule } from '@bryntum/core-angular-thin';
import { BryntumGridModule } from '@bryntum/grid-angular-thin';
import { BryntumSchedulerModule } from '@bryntum/scheduler-angular-thin';
import { BryntumSchedulerProModule } from '@bryntum/schedulerpro-angular-thin';



@NgModule({
  declarations: [
    MoveRouteJobComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RoutePickerModule,
    BryntumCoreModule,
    BryntumGridModule,
    BryntumSchedulerModule,
    BryntumSchedulerProModule,
  ],
  exports: [
    MoveRouteJobComponent
  ]
})
export class MoveRouteJobModule { }
